export const postNewIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
